import { useState } from 'react';
import './TrademarkApplicationsFilter.css';
import { getTrademarkApplications } from '../../utilities/api/trademarkApplications';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';

const defaultTrademarkApplicationsFilters = {
    "clientName": "",
    "applicationType": "",
    "trademarkType": "",
    "filing": "",
    "applicationStatus": "",
    "approvalOrDenial": "",
    "createdAtStart": "",
    "createdAtEnd": "",
    "updatedAtStart": "",
    "updatedAtEnd": "",
}

const applicationTypeOptions = [
    { value: 'us', label: 'US' },
    { value: 'canadian', label: 'Canadian' },
    { value: 'other', label: 'Other' },
]

const trademarkTypeOptions = [
    { value: 'word', label: 'Word' },
    { value: 'image', label: 'Image' },
    { value: 'design', label: 'Design' },
    { value: 'composite', label: 'Composite' },
]

const filingStatusOptions = [
    { value: 'useInCommerce', label: 'Use In Commerce' },
    { value: 'intentToUse', label: 'Intent To Use' },
]

const applicationStatusOptions = [
    { value: 'new', label: 'New' },
    { value: 'officeActionIssued', label: 'Office Action Issued' },
    { value: 'filed', label: 'Filed' },
    { value: 'formalized', label: 'Formalized' },
    { value: 'awaitingExam', label: 'Awaiting Exam' },
    { value: 'examReportIssued', label: 'Exam Report Issued' },
    { value: 'approved', label: 'Approved' },
    { value: 'NOAIssued', label: 'NOA Issued' },
    { value: 'advertised', label: 'Advertised' },
    { value: 'registered', label: 'Registered' },
    { value: 'opposed', label: 'Opposed' },
    { value: 'abandoned', label: 'Abandoned' },
    { value: 'allowed', label: 'Allowed' },
    { value: 'cancelled', label: 'Cancelled' },
]

const approvalOrDenialOptions = [
    { value: 'approved', label: 'Approved' },
    { value: 'denied', label: 'Denied' },
]

export default function TrademarkApplicationsFilter({ user, updateTrademarkApplications, isMobile, sortHeader }) {
    const [filter, setFilter] = useState(defaultTrademarkApplicationsFilters)
    const [loading, setLoading] = useState(false)

    const getApplications = async () => {
        try {
            const allTrademarkApplications = await getTrademarkApplications(user)
            return allTrademarkApplications.sort((a, b) => a[sortHeader] < b[sortHeader] ? 1 : -1)
        } catch (error) {
            console.log(error)
        }
    }

    const resetFilter = async () => {
        setLoading(true)
        // clear content of all input fields
        const form = document.getElementById('trademarkApplicationsFilter');
        for (let i = 0; i < form.elements.length; i++) {
            if (form.elements[i].type === 'text' || form.elements[i].type === 'date' || form.elements[i].type === 'select-one') {
                form.elements[i].value = '';
            }
        }
        setFilter(defaultTrademarkApplicationsFilters)
        const freshApplicationsData = await getApplications();
        updateTrademarkApplications(freshApplicationsData)
        setLoading(false)
    }

    const filterApplications = async () => {
        setLoading(true)
        const freshApplicationsData = await getApplications();
        const cleanedFilter = Object.keys(filter).reduce((acc, key) => {
            if (filter[key]) {
                acc[key] = filter[key];
            }
            return acc;
        }, {});

        const updatedApplicationsList = freshApplicationsData.filter(application => {
            return (
                (cleanedFilter.clientName ? application.clientName.toLowerCase().includes(cleanedFilter.clientName.toLowerCase().trim()) : true) &&
                (cleanedFilter.applicationType ? application.applicationType === cleanedFilter.applicationType : true) &&
                (cleanedFilter.trademarkType ? application.trademarkType === cleanedFilter.trademarkType : true) &&
                (cleanedFilter.filing ? application.filing === cleanedFilter.filing : true) &&
                (cleanedFilter.applicationStatus ? application.applicationStatus === cleanedFilter.applicationStatus : true) &&
                (cleanedFilter.approvalOrDenial ? application.approvalOrDenial === cleanedFilter.approvalOrDenial : true) &&
                (cleanedFilter.createdAtStart ? new Date(application.createdAt) >= new Date(cleanedFilter.createdAtStart) : true) &&
                (cleanedFilter.createdAtEnd ? new Date(application.createdAt) <= new Date(cleanedFilter.createdAtEnd) : true) &&
                (cleanedFilter.updatedAtStart ? new Date(application.updatedAt) >= new Date(cleanedFilter.updatedAtStart) : true) &&
                (cleanedFilter.updatedAtEnd ? new Date(application.updatedAt) <= new Date(cleanedFilter.updatedAtEnd) : true)
            );
        });

        updateTrademarkApplications(updatedApplicationsList);
        setLoading(false)
    }

    const handleChange = (evt) => {
        const newFilterData = {
            ...filter,
            [evt.target.name]: evt.target.value
        }
        setFilter(newFilterData)
    }
  return (
    <div className='TrademarkApplicationsFilter dropdown trademarkApplicationsFilterDropDown'>
        <button className='trademarkApplicationsFilterDropDownToggle' id='trademarkApplicationsFilterDropDownToggle' title='Trademark Applications Filter' data-title='Trademark Applications Filter' data-bs-toggle="dropdown" data-bs-auto-close='outside' aria-expanded="false">
            <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            { !isMobile && <span>Filters</span> }
        </button>
        <div className='dropdown-menu trademarkApplicationsFilterDropDown' aria-labelledby="trademarkApplicationsFilterDropDownToggle">
            <div className='header'>
                <div className='svgContainer'>
                    <svg width="16" height="20" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.5 6H13.5M1 1H16M6 11H11" stroke="#1B2B41" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <span>Filters</span>
            </div>
            <form id='trademarkApplicationsFilter'>
                <div className='form-group'>
                    <label htmlFor="clientName" className='form-label'>Client Name</label>
                    <input type="text" id="clientName" name='clientName' className='form-control' onChange={handleChange} value={filter.clientName} />
                </div>
                <div className='form-group'>
                    <label htmlFor="trademarkType" className='form-label'>Trademark Type</label>
                    <select id="trademarkType" name='trademarkType' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { trademarkTypeOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="applicationType" className='form-label'>Application Type</label>
                    <select id="applicationType" name='applicationType' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { applicationTypeOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="filing" className='form-label'>Filing Status</label>
                    <select id="filing" name='filing' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { filingStatusOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="applicationStatus" className='form-label'>Application Status</label>
                    <select id="applicationStatus" name='applicationStatus' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { applicationStatusOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div className='form-group'>
                    <label htmlFor="approvalOrDenial" className='form-label'>Approval or Denial</label>
                    <select id="approvalOrDenial" name='approvalOrDenial' className='form-select' onChange={handleChange}>
                        <option value="">Show All</option>
                        { approvalOrDenialOptions.map((option, index) => (
                            <option key={index} value={option.value}>{capitalizeFirstLetter(option.label)}</option>
                        ))}
                    </select>
                </div>
                <div>Creation Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="createdAtStart" className='form-label'>Start</label>
                        <input type="date" id="createdAtStart" name='createdAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="createdAtEnd" className='form-label'>End</label>
                        <input type="date" id="createdAtEnd" name='createdAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Last Update</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="updatedAtStart" className='form-label'>Start</label>
                        <input type="date" id="updatedAtStart" name='updatedAtStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="updatedAtEnd" className='form-label'>End</label>
                        <input type="date" id="updatedAtEnd" name='updatedAtEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Submission Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="submissionDateStart" className='form-label'>Start</label>
                        <input type="date" id="submissionDateStart" name='submissionDateStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="submissionDateEnd" className='form-label'>End</label>
                        <input type="date" id="submissionDateEnd" name='submissionDateEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
                <div>Approval Date</div>
                <div className='form-group split'>
                    <div>
                        <label htmlFor="approvalDateStart" className='form-label'>Start</label>
                        <input type="date" id="approvalDateStart" name='approvalDateStart' className='form-control' onChange={handleChange} />
                    </div>
                    <div>
                        <label htmlFor="approvalDateEnd" className='form-label'>End</label>
                        <input type="date" id="approvalDateEnd" name='approvalDateEnd' className='form-control' onChange={handleChange} />
                    </div>
                </div>
            </form>
            <div className='buttonContainer'>
                <button className='btn btn-primary' type='button' onClick={filterApplications} form='trademarkApplicationsFilter' disabled={loading}>Filter</button>
                <button className='btn btn-secondary' type='reset' form='trademarkApplicationsFilter' onClick={resetFilter} disabled={loading}>Reset</button>
            </div>
        </div>
    </div>
  )
}
